import { GamePlayer } from '../models/game-player'
import { GamePlayerDto } from '../dtos/game-player.dto'
import { cardsMapper } from './cards.mapper'
import { trickMapper } from './trick.mapper'
import { DefendOption } from '../models/defend-option'

export const gamePlayerMapper = {
  mapToGamePlayer(gamePlayerDto: GamePlayerDto): GamePlayer {
    return new GamePlayer({
      ...gamePlayerDto,
      defendOption: new DefendOption(gamePlayerDto.defendOption),
      cards: cardsMapper.mapToCards(gamePlayerDto.cards),
      trick: trickMapper.mapToTrick(gamePlayerDto.trick),
      previousTrick: trickMapper.mapToTrick(gamePlayerDto.previousTrick),
      originalCards: cardsMapper.mapToCards(gamePlayerDto.originalCards),
    })
  },
}
